import type { useNavbarModel } from '@/components/shared/navbar/navbar.model'

type NavbarViewProps = ReturnType<typeof useNavbarModel>

export function NavbarView({
  variant,
  links,
  overlayCtaDelayMs,
  isMenuOpen,
  toggleMenu,
  closeMenu,
  handleWordmarkClick,
  contactUrl,
}: NavbarViewProps) {
  return (
    <header className={`fz-navbar fz-navbar--${variant}`}>
      <div className="fz-navbar__row">
        <a
          href="/"
          className="fz-navbar__wordmark"
          onClick={handleWordmarkClick}
        >
          <span className="fz-navbar__wordmark-eyebrow">
            Floricultura-ateliê
          </span>
          <span className="fz-navbar__wordmark-row">
            <span className="fz-navbar__wordmark-name">Flora</span>
            <span className="fz-navbar__wordmark-accent">Ateliê</span>
          </span>
        </a>
        <nav className="fz-navbar__links" aria-label="Navegação principal">
          {links.map((link) => (
            <a key={link.href} href={link.href} className="fz-navbar__link">
              {link.label}
            </a>
          ))}
        </nav>
        <div className="fz-navbar__actions">
          <a
            href="/catalogo"
            className="fz-navbar__shortcut"
            onClick={closeMenu}
          >
            Catálogo
          </a>
          <a href={contactUrl} className="fz-navbar__cta">
            Contato
          </a>
          <button
            type="button"
            className={`fz-navbar__toggle${isMenuOpen ? ' fz-navbar__toggle--open' : ''}`}
            onClick={toggleMenu}
            aria-label={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}
            aria-expanded={isMenuOpen}
            aria-controls="fz-navbar-overlay"
          >
            <span className="fz-navbar__toggle-line" />
            <span className="fz-navbar__toggle-line" />
          </button>
        </div>
      </div>
      <div
        id="fz-navbar-overlay"
        className={`fz-navbar__overlay${isMenuOpen ? ' fz-navbar__overlay--open' : ''}`}
      >
        <nav className="fz-navbar__overlay-links" aria-label="Navegação mobile">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="fz-navbar__overlay-link"
              style={{ transitionDelay: `${link.transitionDelayMs}ms` }}
              onClick={closeMenu}
            >
              {link.label}
            </a>
          ))}
          <a
            href={contactUrl}
            className="fz-navbar__overlay-cta"
            style={{ transitionDelay: `${overlayCtaDelayMs}ms` }}
            onClick={closeMenu}
          >
            Falar por e-mail
          </a>
        </nav>
      </div>
    </header>
  )
}
